import {
  Component,
  OnInit,
  HostListener
} from '@angular/core';

import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { BrowserModule, Title }  from '@angular/platform-browser';


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'join',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./join.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./join.component.html')
})


export class JoinComponent implements OnInit {
  hasChanges :boolean = true;
  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if(this.hasChanges) $event.returnValue='Your data will be lost!';
  }


  /**
   * Set our default values
   */
  public localState = { value: '' };
  public myForm: FormGroup; // our model driven form
  public submitted: boolean; // keep track on whether form is submitted
  membership: string = "full";
  fees:any;
  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title,
    private _fb : FormBuilder
  ) {}

  public ngOnInit() {
    // console.log('hello `join` component');
    this.title.setTitle("The Tiger Club | Join The Club");
    this.fees = this.appState.getFees();

    this.myForm = this._fb.group({
            membership: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]],
            licence: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            licence_number: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            sep_expiry: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            medical_expiry: ['', [<any>Validators.required, <any>Validators.minLength(6)]],
            total_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            p1_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            find_us: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            other_ratings: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            types_flown: ['', [<any>Validators.required, <any>Validators.minLength(3)]]
        });

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
     // $("#main_header").addClass("after_scroll");


    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);


     
  }

  updated_select(val){
    // console.log("UPDATED", val);
    if(val == "asso"){
      this.myForm = this._fb.group({
            membership: [val, [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            find_us: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]]
        });
    } else {
      this.myForm = this._fb.group({
            membership: [val, [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            licence: ['', [<any>Validators.required, <any>Validators.minLength(3)]],
            licence_number: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            sep_expiry: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            dob: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical: ['', [<any>Validators.required, <any>Validators.minLength(4)]],
            medical_expiry: ['', [<any>Validators.required, <any>Validators.minLength(6)]],
            total_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            p1_hours: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            home_address: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            find_us: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            occupation: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            other_ratings: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            types_flown: ['', [<any>Validators.required, <any>Validators.minLength(3)]]
        });
    }
    this.membership = val;

  }

  save(data, valid){
    // console.log("valid", valid);
     //console.log("data", data);
    if(valid){
      // console.log("SAVED?");
      $("#the_form").fadeOut();
      $("#thank_you").fadeIn();

      var membership_name = "";

      switch (data.membership) {
        case "full":
          membership_name = "Full Flying Membership - £"+this.fees.membership.full+" per year";

        break;

        case "temp":
           
          membership_name = "Temporary Flying Membership - £"+this.fees.membership.temp+" per month";


        break;

        case "overseas":
           
          membership_name = "Overseas Flying Membership - £"+this.fees.membership.overseas+" per year";


        break;

        case "asso":
           
          membership_name = "Associate Membership - £"+this.fees.membership.associate+" per year";

        break;       
      }





      data.name = data.first_name+" "+data.last_name;
      data.title = "Membership Request";
      data.membership_name = membership_name;
      //requires a little more stuff for this one / new template
      //SEND THE EMAIL TO USER --> THANK YOU FOR CONTACT
      var user_body = {
          From: "info@tigerclub.co.uk",
          To: data.email,
          TemplateId: 5536623,
          TemplateModel: data
        };
       // console.log("USER SENT HERE ", user_body);

      this.appState.send_email(user_body, 1).subscribe((data: any) => {
          // console.log("USER SENT HERE ", data);
        })


      //SEND THE EMAIL TO STAFF
      var staff_body = {
          From: "info@tigerclub.co.uk",
          To: "info@tigerclub.co.uk",
          TemplateId: 5523702,
          TemplateModel: data
        };


        // console.log("STAFF SENT HERE ", staff_body);
        this.appState.send_email(staff_body, 1).subscribe((data: any) => {
          // console.log("STAFF SENT HERE ", data);
        })





    } else {
       // console.log("FAILED? ", valid);
       // console.log("FAILED? ", data);
      alert("Please complete all fields in the form.");
    }
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/join/join.component.ts